interface MediaItem {
  title: string;
  description: string;
  duration: string;
  views: string;
  tag: string;
  imageAlt: string;
  imageUrl: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '热门综艺高能混剪',
    description: '年度最火爆综艺节目的高能片段混剪，笑点、泪点、燃点一网打尽，五分钟看完一整季精华。',
    duration: '05:28',
    views: '128.6万',
    tag: '混剪',
    imageAlt: '天天影视热门综艺高能混剪视频',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20video%20editing%20workspace%20with%20multiple%20screens%20showing%20colorful%20entertainment%20content%2C%20professional%20editing%20setup%2C%20warm%20creative%20atmosphere%2C%20modern%20studio&width=800&height=450&seq=media-section-01&orientation=landscape',
  },
  {
    title: '真人秀精彩瞬间',
    description: '各大真人秀节目中最令人难忘的经典瞬间，从感人落泪到爆笑不断，每一帧都是回忆。',
    duration: '08:15',
    views: '96.3万',
    tag: '精选',
    imageAlt: '天天影视真人秀综艺节目精彩瞬间',
    imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20TV%20moment%20captured%20with%20warm%20golden%20lighting%2C%20reality%20show%20scene%2C%20candid%20and%20heartfelt%20atmosphere%2C%20soft%20focus%2C%20cinematic%20quality&width=800&height=450&seq=media-section-02&orientation=landscape',
  },
  {
    title: '脱口秀爆笑片段合集',
    description: '《脱口秀大会》《吐槽大会》等节目中最搞笑的段子合集，金句频出笑到停不下来。',
    duration: '06:42',
    views: '215.8万',
    tag: '搞笑',
    imageAlt: '天天影视脱口秀爆笑片段合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comedy%20stage%20with%20performer%20under%20bright%20spotlight%2C%20audience%20laughing%2C%20warm%20and%20joyful%20atmosphere%2C%20entertaining%20live%20show%2C%20vibrant%20energy&width=800&height=450&seq=media-section-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            精彩视频
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            综艺精彩片段
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            精选综艺高光时刻，带你快速领略最精彩的节目精华
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.imageUrl}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}